import store from "@/store";
import i18n, { langFlag, isGuessedLocale, clearGuessedLocale, VALID_LANGS } from "@/lang/index";
import { sessionSnapshot } from "@/utils/session";
import { updateLocale } from "@/api/index";

function isLogged() {
  return !!sessionSnapshot().token;
}

// 用户手动切换：本地即时生效 + 转显式选择 + 登录后异步写 DB（失败不阻塞 UI）
export function setLocale(l) {
  if (!VALID_LANGS.includes(l) || l === i18n.locale) return;
  localStorage.setItem(langFlag, l);
  clearGuessedLocale();
  store.dispatch("config/setLanguage", l);
  if (isLogged()) updateLocale({ locale: l }).catch(() => {});
}

// 登录后语言恢复：只在"本地无显式选择"时用 DB 覆盖，显式选择则回写 DB
export function afterLogin(user = {}) {
  const local = localStorage.getItem(langFlag);
  const guessed = isGuessedLocale();
  if (local && VALID_LANGS.includes(local) && !guessed) {
    // 本机显式选过：尊重本地，但必须回写 DB（否则登录页切换的偏好永远到不了 DB）
    if (user.locale !== local) updateLocale({ locale: local }).catch(() => {});
    return;
  }
  if (!user.locale || !VALID_LANGS.includes(user.locale)) {
    // DB 也没有 → 本机推断值异步补写 DB
    if (guessed && local) updateLocale({ locale: local }).catch(() => {});
    return;
  }
  // 本机是推断值：静默恢复 DB 偏好，无弹窗
  localStorage.setItem(langFlag, user.locale);
  clearGuessedLocale();
  if (user.locale !== i18n.locale) store.dispatch("config/setLanguage", user.locale);
}
